import { TreeStore } from "../../store/treeStore.js";
function useToolbarState(selectedId) {
    const disableCategoryActions = selectedId === TreeStore.ID_ALL || selectedId == null;
    return {
        renameDisabled: disableCategoryActions,
        trashDisabled: disableCategoryActions,
        detailsDisabled: disableCategoryActions
    };
}
export { useToolbarState };
